import { z } from 'zod'

const envSchema = z.object({
  VITE_APP_NAME: z.string().default('Witemedia AI Hub'),
  VITE_API_BASE_URL: z.string().default('/api'),
  VITE_MODEL_CATALOG_ENDPOINT: z.string().default('/member/ai/models'),
  VITE_LANDING_PAGE_ENDPOINT: z.string().default('/open/site-pages/landing'),
  VITE_LANDING_PAGE_MOCK_ENDPOINT: z.string().default('/mock-api/site-pages/landing.json'),
  VITE_LANDING_PAGE_USE_MOCK: z.enum(['true', 'false']).default('false'),
  VITE_ENABLE_MOCK: z.enum(['true', 'false']).default('false'),
})

const result = envSchema.safeParse(import.meta.env)

if (!result.success) {
  throw new Error(`环境变量配置错误: ${z.prettifyError(result.error)}`)
}

export const env = {
  appName: result.data.VITE_APP_NAME,
  apiBaseUrl: result.data.VITE_API_BASE_URL,
  modelCatalogEndpoint: result.data.VITE_MODEL_CATALOG_ENDPOINT,
  landingPageEndpoint: result.data.VITE_LANDING_PAGE_ENDPOINT,
  landingPageMockEndpoint: result.data.VITE_LANDING_PAGE_MOCK_ENDPOINT,
  landingPageUseMock: result.data.VITE_LANDING_PAGE_USE_MOCK === 'true',
  enableMock: result.data.VITE_ENABLE_MOCK === 'true',
} as const
